function $e42e1063c40fb3ef$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler) {
  let {
    checkForDefaultPrevented = true
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return function handleEvent(event) {
    originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
    if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
  };
}

export { $e42e1063c40fb3ef$export$b9ecd428b558ff10 as composeEventHandlers };